import qs from 'qs';

export const getArticleSlug = ({
  params: { id1, id2, id3, id4, id5, id6, id7 },
}: any) => {
  if (id1 === 'tags') {
    return `${id1}/${id2}`;
  }

  if (!id1) {
    return 'default';
  }

  return [id1, id2, id3, id4, id5, id6, id7]
    .filter(item => !!item)
    .join('/') as string;
};

export const extendQueryString = (
  searchString: string,
  additionalParams = {},
) => {
  const query = qs.parse(searchString.replace(/^\?/, ''));

  const result = qs.stringify({
    ...query,
    ...additionalParams,
  });
  return result ? `?${result}` : '';
};
